import styled from 'styled-components'

export const ButtonWrapper = styled.div`
    margin-top: 40px;
    button {
        margin: auto;
        width: 100%;
    }
`
